module.exports = __webpack_public_path__ + "static/assets/img/team_photos.c85f6809.svg";